import {
    Component,
    Input,
} from '@angular/core';

@Component({
    selector: 'hub-authorization-header',
    templateUrl: './hub-authorization-header.component.html',
    styleUrls: ['./hub-authorization-header.component.scss'],
})
export class HubAuthorizationHeaderComponent {
    @Input()
    public showBackButton: boolean = true;

    @Input()
    public onBackClick: () => void;

    @Input()
    public onCloseClick: () => void;
}
